import PropTypes from 'prop-types'
import React from 'react'
import DefaultPageLayout from '../../../layouts/DefaultPageLayout'
import PageBody from './PageBody'
import PageHeader from './PageHeader'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const DefaultPage = ({
  data,
  children,
  showHeader,
  showFooter,
  SiteFooter,
  SiteHeader,
  shouldFixHeader,
  shouldOffsetContent,
  footerMargin,
  termsAndConditionsPath,
  privacyPolicyPath,
  informationStandardPath,
  sideBanner,
  hideBackground,
  hidePrimaryNav,
}) => {
  const {
    page: { authenticationConfig, title, subtitle },
  } = data

  return (
    <DefaultPageLayout
      pageData={data}
      SiteFooter={SiteFooter}
      SiteHeader={SiteHeader}
      showFooter={showFooter}
      sideBanner={sideBanner}
      shouldFixHeader={shouldFixHeader}
      hidePrimaryNav={hidePrimaryNav}
      hideBackground={hideBackground}
      shouldOffsetContent={shouldOffsetContent}
      footerMargin={footerMargin}
      authenticationConfig={authenticationConfig}
      termsAndConditionsPath={termsAndConditionsPath}
      informationStandardPath={informationStandardPath}
      privacyPolicyPath={privacyPolicyPath}
    >
      {showHeader && <PageHeader title={title} subtitle={subtitle} />}
      <PageBody>{children}</PageBody>
    </DefaultPageLayout>
  )
}

DefaultPage.propTypes = {
  data: PropTypes.object.isRequired,
  children: PropTypes.node,
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
  sideBanner: PropTypes.object,
  SiteFooter: PropTypes.func,
  SiteHeader: PropTypes.func,
  shouldFixHeader: PropTypes.bool,
  hideBackground: PropTypes.bool,
  hidePrimaryNav: PropTypes.bool,
  shouldOffsetContent: PropTypes.bool,
  footerMargin: PropTypes.number,
  termsAndConditionsPath: PropTypes.string,
  privacyPolicyPath: PropTypes.string,
  informationStandardPath: PropTypes.string,
}

DefaultPage.defaultProps = {
  children: null,
  showHeader: true,
  showFooter: true,
  sideBanner: undefined,
  SiteFooter: undefined,
  SiteHeader: undefined,
  shouldFixHeader: null,
  hideBackground: null,
  hidePrimaryNav: null,
  shouldOffsetContent: true,
  footerMargin: undefined,
  termsAndConditionsPath: undefined,
  privacyPolicyPath: undefined,
  informationStandardPath: undefined,
}

export default DefaultPage
